import apiReq from '../commontools/api.js'

export function GetSaleModuleExplainAll(corpid){
	var url='/SaleModuleExplainDetail/GetSaleModuleExplainAll/'+corpid;
	return apiReq.get(url);
}
export function AddSaleModuleExplain(info){
	var url='/SaleModuleExplainDetail/AddSaleModuleExplain';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function EditSaleModuleExplain(info){
	var url='/SaleModuleExplainDetail/EditSaleModuleExplain';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function  RefreshSaleModuleExplain(corpid)
{
	var url='/SaleModuleExplainDetail/RefreshSaleModuleExplain/'+corpid;
	return apiReq.get(url);
}
export default{
	GetSaleModuleExplainAll,
	AddSaleModuleExplain,
	EditSaleModuleExplain,
	RefreshSaleModuleExplain
}